export const PRODUCTS_IN_ROW = 4;
export const PRODUCTS_IN_ROW_LAPTOP = 3;
export const PRODUCTS_IN_ROW_TABLET = 2;
export const PRODUCTS_IN_ROW_MOBILE = 1;
export const MOBILE_SCREEN_WIDTH = 490;
export const TABLET_SCREEN_WIDTH = 720;
export const LAPTOP_SCREEN_WIDTH = 992;
export const FIRST_PHASE_ORDER = 0;

export const TRANSLATIONS_PHASE_ORDER_REPLACEMENT = '{phaseOrder}';
export const TRANSLATIONS_STEP_LABEL_REPLACEMENT = '{stepLabel}';
export const TRANSLATIONS_DIET_NAME_REPLACEMENT = '{dietName}';
export const TRANSLATIONS_PORTION_COUNT_REPLACEMENT = '{portionCount}';
export const TRANSLATIONS_MEALS_LIMIT_REPLACEMENT = '{mealsLimit}';
export const TRANSLATIONS_PHASE_STEP_LABEL_REPLACEMENT = '{phaseStepLabel}';
export const TRANSLATIONS_PHASE_NAME_REPLACEMENT = '{phaseName}';
export const TRANSLATIONS_PICKED_PRODUCTS_COUNT_REPLACEMENT = '{pickedProductsCount}';
export const TRANSLATIONS_MATCH_PRODUCT_COUNT_REPLACEMENT = '{matchProductCount}';
export const TRANSLATIONS_MEALS_REPLACEMENT = '{meals}';
export const TRANSLATIONS_CATEGORY_NAME_REPLACEMENT = '{categoryName}';
export const TRANSLATIONS_PRODUCTS_COUNT_REPLACEMENT = '{productsCount}';
export const TRANSLATIONS_PHASE_STEP_REPLACEMENT = '{phaseStep}';
export const TRANSLATIONS_PRODUCT_TITLE_REPLACEMENT = '{product}';
